import { getValue, isEqual } from '@felte/core';
import { createEffect, untrack, createSignal } from 'solid-js';

function createAccessor(store) {
    const subscribed = {};
    const signals = {};
    function felteAccessor(selectorOrPath) {
        if (!selectorOrPath)
            return store();
        if (!subscribed[selectorOrPath.toString()]) {
            const valueSignal = createSignal(getValue(untrack(store), selectorOrPath));
            signals[selectorOrPath.toString()] = valueSignal;
            subscribed[selectorOrPath.toString()] = selectorOrPath;
        }
        const [value] = signals[selectorOrPath.toString()];
        return value();
    }
    createEffect(() => {
        const storeValue = store();
        const keys = Object.keys(subscribed);
        for (const key of keys) {
            const subscriber = subscribed[key];
            const newValue = getValue(storeValue, subscriber);
            const [value, setValue] = signals[subscriber.toString()];
            if (isEqual(newValue, untrack(value)))
                continue;
            setValue(newValue);
        }
    });
    return felteAccessor;
}

export { createAccessor };
//# sourceMappingURL=create-accessor.js.map
